var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kv-chip",class:[_vm.densityClass, _vm.roundedClass, _vm.variantClass, _vm.sizeClass, _vm.colorClass],style:(_vm.chipStyle),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.prependIcon)?_c('Icon',{attrs:{"icon-class":_vm.prependIcon,"size":_vm.calculatedIconSize}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }